import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/AliceSkillForm';

import { Note } from '../Note/Note';

import { DocumentationTypo } from './DocumentationTypo';

const t = i18n(keyset);
const { Paragraph } = DocumentationTypo;

export const DevPreviewBanner: React.FC = () => {
    return (
        <Paragraph>
            <Note type="warning">{t('attention-func-in-dev')}</Note>
        </Paragraph>
    );
};
